import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { UserTokenModel } from '../models/user-token.model';
import { TokenModel } from '../models/token.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  apiUrl: string = 'token/';

  user = new BehaviorSubject<UserTokenModel | null>(null);
  private tokenExpirationTimer: any;

  loginUrl: string = '/auth/login';

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  login(mobileNumber: string, code: number) {
    return this.http
      .post<TokenModel>(environment.baseApi + this.apiUrl, {
        mobileNumber: mobileNumber,
        code: code,
      })
      .pipe(
        tap((resData) => {
          this.handleAuthentication(
            resData.fullName,
            resData.avatar,
            resData.access,
            +resData.expiresIn,
          );
        }),
        catchError(this.handleError),
      );
  }

  autoLogin() {
    const userData: {
      fullName: string;
      avatar: string;
      _token: string;
      _tokenExpirationDate: string;
    } = JSON.parse(localStorage.getItem('afraTrainingPortalUserData'));
    if (!userData) {
      this.router.navigate([this.loginUrl]);
      return;
    }
    const loadedUser = new UserTokenModel(
      userData?.fullName,
      userData?.avatar,
      userData?._token,
      new Date(userData?._tokenExpirationDate),
    );

    if (loadedUser.token) {
      this.user.next(loadedUser);
      const expirationDuration =
        new Date(userData._tokenExpirationDate).getTime() -
        new Date().getTime();
      this.autoLogout(expirationDuration);
    } else {
      this.user.next(null);
      this.router.navigate([this.loginUrl]);
    }
  }

  public logout() {
    this.user.next(null);
    localStorage.removeItem('afraTrainingPortalUserData');
    if (this.tokenExpirationTimer) {
      clearTimeout(this.tokenExpirationTimer);
    }
    this.tokenExpirationTimer = null;
    this.router.navigate([this.loginUrl]);
  }

  autoLogout(expirationDuration: number) {
    this.tokenExpirationTimer = setTimeout(() => {
      this.logout();
    }, expirationDuration);
  }

  private handleAuthentication(
    fullName: string,
    avatar: string,
    access: string,
    expiresIn: number,
  ) {
    const expirationDate = new Date(new Date().getTime() + expiresIn * 1000);
    const user = new UserTokenModel(fullName, avatar, access, expirationDate);
    localStorage.setItem('afraTrainingPortalUserData', JSON.stringify(user));
    this.user.next(user);
    this.autoLogout(expiresIn * 1000);
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => {
      return {
        status: error.status,
        error: error.error,
        ok: error.ok,
        statusText: error.statusText,
        url: error.url,
      };
    });
  }
}
